<div #wrapper class="quick-nav__wrapper">
  <ul role="navigation" class="quicknav quick-nav__nav">
    <li *ngFor="let entry of toc.visibleEntries">
      <a class="quicknav__item" [class.quicknav__item--active]="activeEntry === entry"
         [href]="'#' + entry.fragment" [routerLink]="['.']" [fragment]="entry.fragment"
         (click)="onEntryClick(entry)">
        {{ entry.label }}
      </a>
    </li>
  </ul>
</div>
